import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { handleCallback, hasCodeInUrl, loadUserInfo } from "../../api/auth";
import { FORM_TEXTS } from "../../constants";
import { NavBar } from "../../layout/NavBar";
import { setUser } from "../../redux/userSlice";

export const HomePage = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.user?.profile);
  const verifyCodeInUrl = hasCodeInUrl(window.location);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleUserLoginData = async () => {
      const user = await handleCallback();
      const userProfile = await loadUserInfo(user);
      dispatch(setUser({ ...userProfile.profile }));
    };
    let profile = sessionStorage.getItem("profile");
    if (verifyCodeInUrl && !profile) {
      handleUserLoginData();
    }
  }, [verifyCodeInUrl, dispatch]);

  useEffect(() => {
    let profile = sessionStorage.getItem("profile");
    if (profile) {
      dispatch(setUser(JSON.parse(profile)));
    }
  }, [dispatch]);

  return (
    <>
      <NavBar />
      <div className="grid grid-cols-2 h-90 pt-10 font-sans">
        <div className="col-span-1">
          <img src="/images/Bg.png" className="h-96 w-auto m-auto" alt="" />
        </div>
        <div className="col-span-1 mr-8 text-justify">
          <h4 className="font-medium text-4xl my-4">{FORM_TEXTS.TITLE}</h4>
          {!userInfo?.role && (
            <>
              <button
                className="bg-teal-600 text-white text-center py-2 text-base px-4 font-normal my-3"
                onClick={() => navigate("/create-serviceprovider")}
              >
                {FORM_TEXTS.CREATE_RECORD}
              </button>
              <p className="font-normal text-base py-5 pt-2">
                {FORM_TEXTS.CREATE_RECORD_MESSAGE}
              </p>
            </>
          )}
          <button
            className="bg-blue-950 text-white text-center text-base py-2 px-4 font-normal my-3"
            onClick={() => navigate("/search-serviceprovider")}
          >
            {userInfo && userInfo.role !== ""
              ? FORM_TEXTS.SEARCH_RECORD
              : FORM_TEXTS.UPDATE_RECORD}
          </button>
          <p className="font-normal text-base py-2">
            {userInfo && userInfo.role !== "" ? (
              FORM_TEXTS.UPDATE_RECORD_MESSAGE_INTERNAL
            ) : (
              <div>
                {FORM_TEXTS.UPDATE_RECORD_MESSAGE}
                <span className="block mt-px">
                  {FORM_TEXTS.UPDATE_RECORD_MESSAGE_NOTE}
                </span>
              </div>
            )}
          </p>
        </div>
      </div>
    </>
  );
};
